import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/bugsy.png'


const _hoisted_1 = { class: "absolute inset-0 pointer-events-none overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-0 stars-bg opacity-20"
}
const _hoisted_3 = { class: "max-w-6xl mx-auto px-4 relative z-10" }
const _hoisted_4 = { class: "grid md:grid-cols-3 gap-8 mb-8" }
const _hoisted_5 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_6 = { class: "text-xl font-bold galaxy-text-gradient" }
const _hoisted_7 = { class: "text-white/60" }
const _hoisted_8 = { class: "space-y-3" }
const _hoisted_9 = {
  href: "https://www.facebook.com/StarBugsAcademy/",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center gap-3 text-white/70 hover:text-white transition-colors duration-200 group"
}
const _hoisted_10 = {
  href: "https://www.instagram.com/starbugsacademyy/",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center gap-3 text-white/70 hover:text-white transition-colors duration-200 group"
}
const _hoisted_11 = { class: "flex gap-3" }
const _hoisted_12 = { class: "text-center text-white/50 text-sm" }

import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterSection',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(["relative overflow-hidden py-12 transition-colors duration-500", __props.isDark
      ? 'bg-galaxy-950 text-white'
      : 'bg-gradient-to-b from-primary-800 to-primary-900 text-white'
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.isDark)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute top-0 left-1/3 w-96 h-96 rounded-full blur-3xl opacity-5 bg-nebula-purple" }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute bottom-0 right-1/3 w-80 h-80 rounded-full blur-3xl opacity-5 bg-nebula-cyan" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Bugsy",
              class: "h-10 w-10 object-contain drop-shadow-md transition-transform duration-300 hover:scale-110 hover:rotate-6"
            }, null, -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('nav.brand')), 1)
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('footer.tagline')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h4", {
            class: _normalizeClass(["text-lg font-bold mb-4", __props.isDark ? 'text-nebula-cyan' : 'text-accent-300'])
          }, _toDisplayString(_unref(t)('footer.contact')), 3),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass(["flex h-9 w-9 items-center justify-center rounded-full transition-colors duration-200", __props.isDark ? 'bg-white/10 group-hover:bg-[#1877F2]/30' : 'bg-white/15 group-hover:bg-[#1877F2]/40'])
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("svg", {
                  class: "h-4 w-4 fill-current",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", { d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" })
                ], -1)
              ]))], 2),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-sm" }, "Facebook", -1))
            ]),
            _createElementVNode("a", _hoisted_10, [
              _createElementVNode("span", {
                class: _normalizeClass(["flex h-9 w-9 items-center justify-center rounded-full transition-colors duration-200", __props.isDark ? 'bg-white/10 group-hover:bg-[#E1306C]/30' : 'bg-white/15 group-hover:bg-[#E1306C]/40'])
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("svg", {
                  class: "h-4 w-4 fill-current",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", { d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" })
                ], -1)
              ]))], 2),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-sm" }, "Instagram", -1))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h4", {
            class: _normalizeClass(["text-lg font-bold mb-4", __props.isDark ? 'text-nebula-cyan' : 'text-accent-300'])
          }, _toDisplayString(_unref(t)('footer.social')), 3),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              href: "https://www.facebook.com/StarBugsAcademy/",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": "Facebook",
              class: _normalizeClass(["flex h-11 w-11 items-center justify-center rounded-full transition-all duration-200 hover:scale-110", __props.isDark
                ? 'bg-white/10 text-white/70 hover:bg-[#1877F2]/40 hover:text-white'
                : 'bg-white/15 text-white/70 hover:bg-[#1877F2]/50 hover:text-white'])
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("svg", {
                class: "h-5 w-5 fill-current",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", { d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" })
              ], -1)
            ]))], 2),
            _createElementVNode("a", {
              href: "https://www.instagram.com/starbugsacademyy/",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": "Instagram",
              class: _normalizeClass(["flex h-11 w-11 items-center justify-center rounded-full transition-all duration-200 hover:scale-110", __props.isDark
                ? 'bg-white/10 text-white/70 hover:bg-[#E1306C]/40 hover:text-white'
                : 'bg-white/15 text-white/70 hover:bg-[#E1306C]/50 hover:text-white'])
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                class: "h-5 w-5 fill-current",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", { d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" })
              ], -1)
            ]))], 2)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["border-t mb-6", __props.isDark ? 'border-galaxy-700/30' : 'border-white/20'])
      }, null, 2),
      _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('footer.copyright')), 1)
    ])
  ], 2))
}
}

})